import { render } from "./sidebarNavigation.vue?vue&type=template&id=38290307"
import script from "./sidebarNavigation.vue?vue&type=script&lang=js"
export * from "./sidebarNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__